export default {
  userSettings: 'User Settings',
  name: 'Name',
  email: 'Email',
  role: 'Role',
  actions: 'Actions',
  addUserInfo: 'Please add user info and set a role.',
  createUser: 'Create user',
  editUser: 'Edit user',
  firstName: 'First Name',
  lastName: 'Last Name',
  create: 'Create',
  inputFirstName: 'Input first name',
  inputLastName: 'Input last name',
  inputEmail: 'email@skyri.se',
  selectRole: 'Select role',
  cancelUserEditingProcess:
    'Are you sure you want to close the User editing process? You will lose all changes.',
  cancelUserCreationProcess:
    'Are you sure you want to close the User creation process? You will lose all progress.',
  cancelModalTitle: 'Close without saving',
  deleteUserModalTitle: 'Delete User',
  deleteUserModalDescription: 'Are you sure you want to delete this User? This action cannot be undone.',
  emailDomainError: 'Email domain must be {{domains}}.',
  emailFormatError: 'Invalid email format.',
  userHasBeenCreated: 'User has been created successfully.',
  userHasBeenDeleted: 'User has been deleted successfully.',
  userHasBeenEdited: 'Your changes have been successfully saved.'
} as Record<string, string>;
